import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { LogItem } from '../../interfaces';

@Component({
  selector: 'phoenix-process-log',
  templateUrl: './process-log.component.html',
  styleUrl: './process-log.component.scss',
  imports: [MatIconModule, CommonModule],
  standalone: true,
})
export class ProcessLogComponent {
  @Input() logList: LogItem[] = [];
}
